import { Heading, Paragraph, Stack, Text } from '@customerio/pluma-components/react';
import type { ReactNode } from 'react';

type SheetSectionProps = {
  eyebrow: string;
  heading?: string;
  lede?: ReactNode;
  children: ReactNode;
};

export function SheetSection({ eyebrow, heading, lede, children }: SheetSectionProps) {
  return (
    <Stack as="section" gap="150">
      <Stack gap="050">
        <Text size="xxs" weight="bold" color="accent" textTransform="uppercase">
          {eyebrow}
        </Text>
        {heading == null ? null : <Heading level="3">{heading}</Heading>}
        {lede == null ? null : (
          <Paragraph size="sm" color="secondary">
            {lede}
          </Paragraph>
        )}
      </Stack>
      {children}
    </Stack>
  );
}
